import { getYear, subYears } from 'date-fns';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { QUERY_PARAM_VALUE } from '_constants/queryParams';
import { theme } from '_constants/theme';
import { useTaxFilingQueryParam } from '_hooks';

import Tabs from 'components/atomic/Tabs';
import Text from 'components/atomic/layouts/Text';
import BookMeetingView from 'components/composed/views/BookMeetingView';
import TaxConfirmInfoView from 'components/composed/views/TaxConfirmInfoView';
import TaxDocumentsView from 'components/composed/views/TaxDocumentsView';
import TaxMonitoringView from 'components/composed/views/TaxMonitoringView';
import TaxReturnsView from 'components/composed/views/TaxReturnsView';

// import TaxPaymentsWidget from 'components/composed/widgets/TaxPaymentsWidget';

const StyledContainer = styled.div`
  padding: ${theme.spaces.smallX}px;
  background: #e0d4fe52;
  border-radius: 24px;
`;

const StyledNavContainer = styled.div`
  padding-left: ${theme.spaces.smallX}px;
  padding-right: ${theme.spaces.smallX}px;

  > * {
    padding-bottom: ${theme.spaces.large}px;

    &:first-child {
      padding-bottom: unset;
    }
  }
`;

const StyledViewsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spaces.smallX}px;

  > * {
    &:first-child {
      flex-grow: 1;

      > div {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    &:last-child {
      min-width: 360px;
    }
  }

  @media ${theme.devices.tablet} {
    flex-direction: column;

    > * {
      &:last-child {
        min-width: unset;
      }
    }
  }
`;

const StyledCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.smallX}px;
`;

const CurrentTaxYearSection = () => {
  const [taxFilingParamValue, setTaxFilingParamValue] = useTaxFilingQueryParam();

  const handleSelectTab = (tabId) => {
    setTaxFilingParamValue(tabId);
  };

  return (
    <StyledContainer>
      <StyledNavContainer>
        <Text
          size={theme.fontSizes.medium}
          weight={600}
          color={theme.colors.indigo.primary}
          bottomSpace={theme.spaces.smallX}
        >
          Start {getYear(subYears(new Date(), 1))} Tax Filing Now
        </Text>
        <Tabs
          color={theme.colors.indigo.primary}
          selected={taxFilingParamValue}
          items={[
            {
              tabId: QUERY_PARAM_VALUE.uploadDocuments,
              iconAlias: ICON_ALIASES.documentText,
              title: 'Upload Documents',
            },
            {
              tabId: QUERY_PARAM_VALUE.confirmInfo,
              iconAlias: ICON_ALIASES.archiveTick,
              title: 'Confirm Information',
            },
            {
              tabId: QUERY_PARAM_VALUE.checkingStages,
              iconAlias: ICON_ALIASES.star,
              title: 'Checking Stages',
            },
          ]}
          onSelect={handleSelectTab}
        />
      </StyledNavContainer>
      <StyledViewsContainer>
        <StyledCol>
          {taxFilingParamValue === QUERY_PARAM_VALUE.uploadDocuments && <TaxDocumentsView />}
          {taxFilingParamValue === QUERY_PARAM_VALUE.confirmInfo && <TaxConfirmInfoView />}
          {taxFilingParamValue === QUERY_PARAM_VALUE.checkingStages && <TaxMonitoringView />}
        </StyledCol>
        <StyledCol>
          <TaxReturnsView currentOnly />
          <BookMeetingView />
          {/* <TaxPaymentsWidget /> */}
        </StyledCol>
      </StyledViewsContainer>
    </StyledContainer>
  );
};

export default CurrentTaxYearSection;
